const OUTBOUND_LINK_STORAGE_KEY = 'ash-outbound-link';

export const markOutboundLinkOpened = (destinationUrl) => {
  if (typeof window === 'undefined' || !destinationUrl) {
    return;
  }

  try {
    window.sessionStorage.setItem(OUTBOUND_LINK_STORAGE_KEY, destinationUrl);
  } catch (error) {
    // sessionStorage is unavailable in some in-app/private browsers
  }
};

export const consumeOutboundLinkOpened = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const destinationUrl = window.sessionStorage.getItem(
      OUTBOUND_LINK_STORAGE_KEY
    );
    window.sessionStorage.removeItem(OUTBOUND_LINK_STORAGE_KEY);

    return destinationUrl;
  } catch (error) {
    return null;
  }
};
